// https://micromodal.now.sh/

function modalInit() {
	MicroModal.init({
		awaitCloseAnimation: true
		// onShow: modal => console.info(`${modal.id} is shown`),
		// onClose: modal => console.info(`${modal.id} is hidden`)
	});
}
